// Central content for Reentry Staffing — Maritime Workforce Operating System

// Pexels direct MP4s — verified to play cross-origin in-app (hero uses same host).
const PX = {
  weldSteel: "https://videos.pexels.com/video-files/6046350/6046350-sd_640_360_24fps.mp4",
  weldBeam: "https://videos.pexels.com/video-files/29626530/12748634_640_360_30fps.mp4",
  sparks: "https://videos.pexels.com/video-files/27928828/12265969_640_360_50fps.mp4",
  weldShop: "https://videos.pexels.com/video-files/31016918/13258038_640_360_30fps.mp4",
  fireGlow: "https://videos.pexels.com/video-files/29913841/12840108_640_360_24fps.mp4",
  welder: "https://videos.pexels.com/video-files/4941454/4941454-sd_640_360_25fps.mp4",
};

export const VIDEOS = {
  heroLoop: PX.weldSteel,
  firewatch: PX.fireGlow,
  fire2: PX.fireGlow,
  osha: PX.weldBeam,
  welding: PX.weldShop,
  electrical: PX.weldBeam,
  structural: PX.sparks,
  pipefitting: PX.welder,
  rigging: PX.sparks,
  machinist: PX.weldShop,
  coatings: PX.welder,
  carpentry: PX.weldBeam,
  placement: PX.weldSteel,
};

// Clip per trade id (Level Up cards)
export const TRADE_VIDEOS = {
  welding: VIDEOS.welding,
  structural: VIDEOS.structural,
  pipefitting: VIDEOS.pipefitting,
  electrical: VIDEOS.electrical,
  "inside-machinist": VIDEOS.machinist,
  "outside-machinist": VIDEOS.machinist,
  rigging: VIDEOS.rigging,
  coatings: VIDEOS.coatings,
  "sheet-metal": VIDEOS.welding,
  insulation: VIDEOS.osha,
  carpentry: VIDEOS.carpentry,
  "firewatch-trade": VIDEOS.firewatch,
};

export const IMAGES = {
  heroWelder: "https://images.unsplash.com/photo-1758574697274-ebbbd08ec0d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzaGlweWFyZCUyMHdlbGRlciUyMHdvcmtlciUyMHNoaXAlMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc4NzEwMDc3MXww&ixlib=rb-4.1.0&q=85",
  drydockVessel: "https://images.unsplash.com/photo-1602575051429-c502cac0d3e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxuYXZhbCUyMHNoaXB5YXJkJTIwZHJ5ZG9jayUyMHZlc3NlbCUyMGluZHVzdHJpYWwlMjBjcmFuZXxlbnwwfHx8fDE3ODcxMDA3NzJ8MA&ixlib=rb-4.1.0&q=85",
  blueprint: "https://images.unsplash.com/photo-1781330170780-76052428a258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxibHVlcHJpbnQlMjBhcmNoaXRlY3R1cmFsJTIwZHJhd2luZyUyMGluZHVzdHJpYWwlMjBlbmdpbmVlcmluZyUyMHNoaXB8ZW58MHx8fHwxNzg3MTAwNzc4fDA&ixlib=rb-4.1.0&q=85",
  hotWork: "https://images.unsplash.com/photo-1464963160608-a6834f70b421?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzaGlweWFyZCUyMHdlbGRlciUyMHdvcmtlciUyMHNoaXAlMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc4NzEwMDc3MXww&ixlib=rb-4.1.0&q=85",
  repairCrane: "https://images.pexels.com/photos/12583030/pexels-photo-12583030.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  sparks: "https://images.unsplash.com/photo-1563083165-32e6c6918e49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxzaGlweWFyZCUyMHdlbGRlciUyMHNwYXJrcyUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzg3MTAwODIxfDA&ixlib=rb-4.1.0&q=85",
  portraitPipe: "https://images.unsplash.com/photo-1651499910684-b6b82c2da504?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxwaXBlZml0dGluZyUyMHN0cnVjdHVyYWwlMjBzdGVlbCUyMHdvcmtlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzEwMDgyMXww&ixlib=rb-4.1.0&q=85",
  portraitRed: "https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxwaXBlZml0dGluZyUyMHN0cnVjdHVyYWwlMjBzdGVlbCUyMHdvcmtlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzEwMDgyMXww&ixlib=rb-4.1.0&q=85",
};

export const BASES = [
  "Norfolk Naval Shipyard, VA",
  "Newport News, VA",
  "San Diego, CA",
  "Bremerton (Puget Sound), WA",
  "Mayport, FL",
  "Groton (Electric Boat), CT",
  "Pearl Harbor, HI",
];

export const PIPELINE = [
  {
    id: "apply",
    key: "apply",
    icon: "ClipboardList",
    label: "Apply",
    step: "01",
    eta: "~10 min",
    tag: "OPEN INTAKE",
    tagline: "Create a profile & complete initial workforce screening.",
    whatItIs:
      "The entry point. You create a candidate profile and complete a short workforce-readiness screening so we can match you to the right starting track.",
    whoNeeds: "Anyone entering the maritime / shipyard workforce — no prior experience required.",
    documents: ["Government-issued ID", "Basic work history", "Availability & preferred shift", "Reliable transportation info", "Desired trade / experience level"],
    where: "Completed online here, or with a Reentry Staffing recruiter by phone.",
    after: "A recruiter reviews your screening and routes you into Firewatch training as your entry point.",
    baseNote: "No installation access is required to apply.",
    cta: "Start My Application",
  },
  {
    id: "firewatch",
    key: "firewatch",
    icon: "Flame",
    label: "Firewatch",
    step: "02",
    eta: "1–2 days",
    tag: "ENTRY TRAINING",
    tagline: "Your entry point into maritime & industrial careers.",
    whatItIs:
      "Firewatch training covers the fundamentals of fire prevention and hot-work safety. It is the primary entry-level program and a launchpad into higher trades — not a dead end.",
    whoNeeds: "Every entry-level candidate. Firewatch is the fastest way onto a shipyard.",
    documents: ["Hot-work awareness", "Fire prevention", "Hazard recognition", "PPE fundamentals", "Emergency procedures", "Fire extinguisher awareness", "Shipyard communication", "Firewatch responsibilities"],
    where: "Delivered through Reentry Staffing workforce-readiness training and coordinated training partners.",
    after: "Once complete, the OSHA / Safety step unlocks and the credential appears in your digital trades passport.",
    baseNote: "We do not make claims of certification, regulatory approval, or guaranteed employment. Completion reflects training attendance and competency.",
    cta: "Start Firewatch Training",
    video: VIDEOS.firewatch,
  },
  {
    id: "osha",
    key: "osha",
    icon: "HardHat",
    label: "OSHA / Safety",
    step: "03",
    eta: "1–3 days",
    tag: "SAFETY",
    tagline: "Complete the applicable workplace & maritime safety training.",
    whatItIs:
      "Applicable OSHA and maritime safety training that shipyards and contractors expect. Completed safety training is displayed inside your digital worker profile.",
    whoNeeds: "Candidates progressing past Firewatch toward workforce-ready status.",
    documents: ["OSHA 10 / 30 (as applicable)", "Maritime safety orientation (1915 topics)", "Fall protection awareness", "Confined space awareness", "Hazard communication"],
    where: "Through Reentry Staffing and authorized training partners.",
    after: "Verified safety training is added to your passport; the DBIDS / Access step unlocks.",
    baseNote: "Training requirements vary by employer and site.",
    cta: "View Safety Requirements",
    video: VIDEOS.osha,
  },
  {
    id: "dbids",
    key: "dbids",
    icon: "IdCard",
    label: "DBIDS / Access",
    step: "04",
    eta: "Varies by base",
    tag: "ACCESS READINESS",
    tagline: "Complete applicable DBIDS enrollment & installation access readiness.",
    whatItIs:
      "DBIDS (Defense Biometric Identification System) supports installation and base-access readiness. We help you complete applicable enrollment, identity verification, sponsorship, and access requirements.",
    whoNeeds: "Workers assigned to projects on military installations or controlled facilities.",
    documents: ["Valid government-issued photo ID", "Proof of citizenship / work authorization", "Employer / sponsor information", "Background & identity verification", "Any base-specific documentation"],
    where: "Enrollment happens at the installation's Visitor Control Center / DBIDS office once sponsored by an employer.",
    after: "Your access status is tracked in your passport as Enrolled / Screening / Access Determined by authority.",
    baseNote:
      "Completing DBIDS enrollment does NOT automatically guarantee access to any military installation. Final access authorization is determined by the appropriate installation / authority and may depend on employer sponsorship and other requirements.",
    cta: "View Access Process",
  },
  {
    id: "verified",
    key: "verified",
    icon: "ShieldCheck",
    label: "Workforce Ready",
    step: "05",
    eta: "Milestone",
    tag: "VERIFIED",
    tagline: "Your digital trades passport progresses to workforce ready.",
    whatItIs:
      "Once applicable requirements are complete, your profile advances toward Workforce Ready — a verified digital trades passport employers can review.",
    whoNeeds: "Candidates who have completed Firewatch, safety, and applicable access readiness.",
    documents: ["Firewatch training", "OSHA / safety training", "DBIDS / access status (where applicable)", "Trade skills & work experience", "Availability & preferred shift", "Resume & verified credentials"],
    where: "Maintained in your Reentry Staffing worker portal.",
    after: "You become visible to participating shipyards and contractors for placement.",
    baseNote: "'Verified' is shown only when information has actually been verified.",
    cta: "View My Passport",
  },
  {
    id: "placement",
    key: "placement",
    icon: "Ship",
    label: "Placement",
    step: "06",
    eta: "Ongoing",
    tag: "STAFFING",
    tagline: "Connect with participating shipyards, contractors & employers.",
    whatItIs:
      "We connect workforce-ready candidates with shipyards, ship-repair contractors, defense contractors, and industrial employers — then help you advance into a skilled trade.",
    whoNeeds: "Workforce-ready candidates seeking placement and career growth.",
    documents: ["Shipyards & drydocks", "Ship repair contractors", "Defense contractors", "Maritime & industrial employers", "Manufacturing employers"],
    where: "Through the Reentry Staffing job marketplace and recruiter-led matching.",
    after: "After placement, choose the trade you want to build and follow its career roadmap.",
    baseNote: "Placement depends on qualifications, employer needs, and access requirements.",
    cta: "Find Shipyard Jobs",
  },
];

export const TRADES = [
  { id: "welding", name: "Welding", icon: "Flame", demand: 96, wage: "$28 → $52/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Introduction to Welding", "Welding Training", "Process-Specific (SMAW/FCAW/GMAW/GTAW)", "Qualified / Certified Welder*", "Shipyard Welder", "Advanced Welder", "Lead / Supervisor"] },
  { id: "structural", name: "Structural / Shipfitting", icon: "Anvil", demand: 92, wage: "$26 → $46/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Entry-Level Maritime Experience", "Core Craft Skills", "Structural Fitter Training", "Shipfitter", "Journeyman", "Lead", "Supervisor"] },
  { id: "pipefitting", name: "Pipefitting", icon: "Wrench", demand: 88, wage: "$27 → $48/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Core Craft Skills", "Pipefitter Training", "Marine Pipefitter", "Journeyman", "Lead", "Supervisor"] },
  { id: "electrical", name: "Marine Electrical", icon: "Zap", demand: 90, wage: "$29 → $54/hr", partner: true,
    roadmap: ["Firewatch", "Safety / OSHA", "Electrical Fundamentals", "Marine Electrical Training", "Marine Electrician", "Journeyman", "Lead", "Supervisor"] },
  { id: "inside-machinist", name: "Inside Machinist", icon: "Cog", demand: 78, wage: "$26 → $47/hr", partner: true,
    roadmap: ["Firewatch", "Safety / OSHA", "Machining Fundamentals", "CNC / Manual Training", "Inside Machinist", "Journeyman", "Lead"] },
  { id: "outside-machinist", name: "Outside Machinist", icon: "Settings", demand: 80, wage: "$27 → $49/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Mechanical Fundamentals", "Outside Machinist Training", "Outside Machinist", "Journeyman", "Lead"] },
  { id: "rigging", name: "Rigging", icon: "Anchor", demand: 84, wage: "$30 → $50/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Rigging Fundamentals", "Heavy Rigging Training", "Rigger", "Advanced Rigger", "Lead / Crane Ops"] },
  { id: "coatings", name: "Marine Coatings", icon: "Paintbrush", demand: 74, wage: "$24 → $38/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Surface Prep", "Blast & Paint Training", "Marine Coatings Tech", "Lead"] },
  { id: "sheet-metal", name: "Sheet Metal", icon: "Layers", demand: 70, wage: "$25 → $42/hr", partner: true,
    roadmap: ["Firewatch", "Safety / OSHA", "Sheet Metal Fundamentals", "Fabrication Training", "Sheet Metal Mechanic", "Journeyman", "Lead"] },
  { id: "insulation", name: "Insulation", icon: "Box", demand: 66, wage: "$23 → $36/hr", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Insulation Fundamentals", "Marine Insulation Training", "Insulator", "Lead"] },
  { id: "carpentry", name: "Carpentry", icon: "Hammer", demand: 68, wage: "$24 → $40/hr", partner: true,
    roadmap: ["Firewatch", "Safety / OSHA", "Carpentry Fundamentals", "Marine Carpentry Training", "Ship Carpenter", "Journeyman", "Lead"] },
  { id: "firewatch-trade", name: "Firewatch", icon: "Flame", demand: 99, wage: "$15 → $25/hr entry", partner: false,
    roadmap: ["Firewatch", "Safety / OSHA", "Confined Space / Hole Watch", "Senior Firewatch", "Lead Firewatch", "Into a Skilled Trade"] },
];

export const ROADMAP_DETAIL = {
  default: {
    does: "Performs the craft work for this trade to maritime and contractor standards, supporting ship construction, repair, and overhaul.",
    skills: "Blueprint reading, hand & power tools, measurement, safety discipline, and craft-specific technique.",
    training: "Firewatch + Safety are prerequisites. Craft training delivered directly or through an approved training partner.",
    credentials: "Trade-specific qualifications earned and verified as competency is demonstrated.",
    experience: "Progresses from entry-level exposure to journeyman and lead over time on real projects.",
  },
};

export const MANIFESTO = [
  { n: "01", title: "The Workforce Gap", body: "America's shipyards face a historic shortage of skilled trades. We build workers from the ground up — starting with Firewatch." },
  { n: "02", title: "The Fast-Track Protocol", body: "Firewatch → OSHA → DBIDS readiness → placement. A clear, verifiable path from day one to the drydock." },
  { n: "03", title: "Direct Contractor Placement", body: "Workforce-ready candidates are matched with participating shipyards, ship-repair, defense, and industrial employers." },
  { n: "04", title: "We Don't Just Find Jobs", body: "We build skilled workers. Every candidate can keep advancing into a higher-skilled maritime trade and career." },
];

export const STATS = [
  { value: 12, suffix: "", label: "Skilled trade pathways" },
  { value: 7, suffix: "", label: "Shipyard regions" },
  { value: 6, suffix: "-step", label: "Readiness protocol" },
  { value: 0, prefix: "$", suffix: "", label: "Cost to start Firewatch", zeroText: "0" },
];

export const NAV_LINKS = [
  { label: "Careers", href: "#pathway" },
  { label: "Training", href: "#pathway" },
  { label: "Career Pathways", href: "#trades" },
  { label: "Find Jobs", href: "#jobs" },
  { label: "Employers", href: "#employers" },
  { label: "Training Partners", href: "#partners" },
  { label: "About", href: "#manifesto" },
];

export const TRACK_OPTIONS = [
  "Firewatch (Entry)", "Welding", "Structural / Shipfitting", "Pipefitting",
  "Marine Electrical", "Rigging", "Marine Coatings", "Machinist", "Undecided",
];

export const DASHBOARD = {
  progress: 65,
  items: [
    { icon: "Flame", label: "Firewatch", status: "COMPLETE" },
    { icon: "HardHat", label: "OSHA / Safety", status: "COMPLETE" },
    { icon: "IdCard", label: "DBIDS / Access Process", status: "IN PROGRESS" },
    { icon: "FileText", label: "Resume", status: "COMPLETE" },
    { icon: "Ship", label: "Placement", status: "NEXT STEP" },
  ],
  nextMove: {
    role: "Structural Fitter",
    trainingNeeded: ["Core Craft Skills", "Structural Fitter Training"],
    completed: ["Firewatch", "OSHA 10", "Confined Space Awareness"],
    missing: ["Structural Fitter Training", "Employer Sponsorship (DBIDS)"],
  },
};

export const EMPLOYER_DASH = [
  { label: "Available Talent", value: 248, tone: "green" },
  { label: "Candidates In Training", value: 92, tone: "amber" },
  { label: "Workforce Ready", value: 61, tone: "green" },
  { label: "Assigned Workers", value: 134, tone: "blue" },
  { label: "Expiring Credentials", value: 7, tone: "ember" },
  { label: "Open Requests", value: 15, tone: "blue" },
];
